import { apiBase, getToken } from '../api';

/**
 * Reporta un evento del navegador al log del servidor (storage/logs/cliente-*.log).
 *
 * Existe porque hay fallos que nunca llegan al backend: si el navegador no manda la petición,
 * ni el log de acceso ni el de Laravel ven nada. Es fire-and-forget: NUNCA lanza ni bloquea.
 *
 * Usa fetch directo y no `apiRaw` a propósito: ante un 401 sin refresh posible, apiRaw hace
 * `forceLogout()` (recarga la página), y un log no debe poder destruir el formulario que el
 * usuario está llenando. `keepalive` deja que la petición sobreviva a una recarga.
 *
 * NO mandar respuestas de formularios ni datos clínicos: sólo qué pasó, no qué se contestó.
 */
export function logCliente(evento, datos = {}) {
  try {
    const token = getToken();
    if (!token) return;
    fetch(`${apiBase}/api/log-cliente`, {
      method: 'POST',
      keepalive: true,
      headers: { Accept: 'application/json', 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify({
        evento,
        datos: { ...datos, pantalla: `${window.innerWidth}x${window.innerHeight}`, ruta: window.location.pathname },
      }),
    }).catch(() => {});
  } catch {
    /* el logging jamás debe romper la pantalla */
  }
}

/**
 * Se llama justo después de abrir la encuesta sociodemográfica. Mide el modal ya renderizado:
 * su CSS fija `width: 70vh` sin regla para teléfono, y `desborda: true` (modal más ancho que la
 * pantalla) confirmaría que en un celular el formulario queda recortado.
 */
export function logEncuestaAbierta(turno) {
  setTimeout(() => {
    try {
      const r = document.querySelector('.modal-datos-paciente')?.getBoundingClientRect();
      logCliente('encuesta.abierta', {
        idTurno: turno?.idTurno ?? null,
        idPaciente: turno?.idPaciente ?? null,
        modalAncho: r ? Math.round(r.width) : null,
        modalAlto: r ? Math.round(r.height) : null,
        desborda: r ? r.width > window.innerWidth : null,
      });
    } catch {
      /* idem */
    }
  }, 400);   // deja que react-modal termine de pintar
}
